module.exports = __webpack_public_path__ + "static/media/pack-fr.b026cc98.png";